// Stripe price ids. EMPTY means the paywall is off and everything is unlocked —
// which is the right default: an app that gates features before payments work
// is an app that looks broken.

export const prices = { monthly: '', annual: '' };
export const priceDisplay = { monthly: '', annual: '' };
export const paywallAvailable = () => !!(prices.monthly || prices.annual);
